import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "articledetail" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "time" }
const _hoisted_4 = ["innerHTML"]

import {useRoute} from 'vue-router'
import {onMounted,ref} from "vue";
import newsApi from "@/utils/Api/News";
import wx from "weixin-js-sdk";
import commMethods from "@/assets/ts/common";

export default /*@__PURE__*/_defineComponent({
  __name: 'articledetail',
  setup(__props) {

onMounted(()=>{
  document.title='文章详情';
  //分享
  commMethods.getTicket(['updateAppMessageShareData','updateTimelineShareData','hideMenuItems'])

  getData();
  wx.ready(()=>{

    wx.updateAppMessageShareData({
      title: info.value.contentTitle, // 分享标题
      desc: '', // 分享描述
      // link: 'http://192.168.3.6:81?id='+route.query.id, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致

      link: 'https://mobile.dqhmbz.com/articledetail?id='+route.query.id, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl:info.value.contentCover, // 分享图标
      success: function () {
        // 设置成功
        console.log(111)
        // showToast({
        //   message:'分享成功'
        // });
      },
      fail:(err)=>{
        // showToast({
        //   message:err
        // });
      }
    })

    wx.updateTimelineShareData({
      title: info.value.contentTitle, // 分享标题
      // link: 'http://192.168.3.6:81?id='+route.query.id, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致

      link: 'https://mobile.dqhmbz.com/articledetail?id='+route.query.id, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl:info.value.contentCover, // 分享图标
      success: function () {
        // 设置成功
      }
    })
  })
})
const route=useRoute();
const info=ref({});
const getData=()=>{
  newsApi.detail(route.query.id).then(res=>{
    console.log(res)
    info.value=res.data;

  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(info.value.contentTitle), 1),
    _createElementVNode("div", _hoisted_3, "发布日期：" + _toDisplayString(info.value.contentTime), 1),
    _createElementVNode("div", {
      class: "content flex-1",
      innerHTML: info.value.contentMain
    }, null, 8, _hoisted_4)
  ]))
}
}

})